import { Skeleton, Tag, TagProps, Text, useColorModeValue } from '@chakra-ui/react';
import { Request, RequestStatus } from '@pelicargo/types';
import { getPrettyRequestStatus } from '@pelicargo/utils';
import { useMemo } from 'react';

import { requestStatusUI } from '../utils/constants';
import { Request as LocalRequest } from '../utils/types';

type Props = TagProps & {
  isLoaded: boolean;
  status: RequestStatus | Request['status'] | LocalRequest['status'] | null;
};

export const RequestStatusTag = ({ status, isLoaded = true, ...rest }: Props) => {
  const { label, variant, colorScheme } = useMemo(() => {
    if (!status) return { label: '', variant: '', colorScheme: '' };

    const label = getPrettyRequestStatus(status as RequestStatus);
    const { variant, colorScheme } = requestStatusUI[status];

    return { label, variant, colorScheme };
  }, [status]);

  const captionColor = useColorModeValue(`${colorScheme}.600`, `${colorScheme}.200`);

  if (!status) return null;

  if (variant === 'ghost') {
    return (
      <Skeleton isLoaded={isLoaded}>
        <Text fontSize={rest.size} textStyle="captionSmallMedium" color={captionColor} py={1}>
          {label}
        </Text>
      </Skeleton>
    );
  }

  return (
    <Skeleton isLoaded={isLoaded}>
      <Tag size="sm" borderRadius="sm" colorScheme={colorScheme} variant={variant} {...rest}>
        {label}
      </Tag>
    </Skeleton>
  );
};
